/**
 * @module Radio
 */

import Component from '../Component';
import './styles.css';

/**
 * Радиобаттоны.
 */
export default class Radio extends Component {
    static className = 'radio';

    initElements() {
        this.elements = {
            $label: $('.radio__label', this.$block),
            $input: $('.radio__input', this.$block),
        };
    }
}
